import { render, staticRenderFns } from "./CNICRegistrarList.vue?vue&type=template&id=2e104fcf"
import script from "./CNICRegistrarList.vue?vue&type=script&lang=js"
export * from "./CNICRegistrarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports